module.exports = __webpack_public_path__ + "img/ZB53详情页_04.fce0853a.jpg";